// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"141":"a30979d9","498":"e7eea755","553":"ca205904","591":"c3c27bff","703":"ae958b64","787":"9c0aa911"}[chunkId] + ".chunk.js";
};